import { CardMedia, IconButton, ImageListItem, ImageListItemBar, Paper, Typography } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import React from "react"

export const MediaItem = ({
    item,
    onDelete,
    isImageNotVideo,
}) => {
    // AR videos are usually portrait (9:16), so a shared 100px height with auto width
    // shrinks them to an unreadable sliver. Give video its own taller, wider box.
    const MediaItemCore = () => isImageNotVideo ?
            <img
                src={item?.url}
                loading="lazy"
                style={{border: "none", height: 100}}
            />
        :
            <CardMedia
                sx={{
                    border: "none",
                    height: 220,
                    width: 140,
                }}
                controls
                src={item?.url}
                component='video'
            />

    return (
        <ImageListItem>
            <Paper elevation={12} style={{height: isImageNotVideo ? 95 : 220}}>
                <MediaItemCore />
            </Paper>
            <ImageListItemBar
                sx={{
                    background:
                    'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                    'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                }}
                title={<Typography>{item?.name}</Typography>}
                position="top"
                actionIcon={
                    <IconButton
                        sx={{ color: 'white' }}
                        onClick={()=>onDelete(item?.url)}
                    >
                        <DeleteIcon color="secondary" />
                    </IconButton>
                }
                actionPosition="right"
            />
        </ImageListItem>
    )
}